module.exports = __webpack_public_path__ + "static/media/cross.9752125b.svg";